import React, {useEffect, useState} from 'react';
import {FormikProps, FormikValues} from "formik";
import {sleep} from "meilisearch";


interface IEditorFormSyncProps {
  form: FormikProps<FormikValues>;
  outsideFormValues?: any;
  setOutsideFormValues: (outsideFormValues, callback: any) => void;

}

const EditorFormSync = (props: IEditorFormSyncProps) => {
  const [sendingUpdate, setSendingUpdate] = useState(false);
  useEffect(() => {
    if (sendingUpdate === false) {
      setSendingUpdate(true);
   //  console.log(9999,props.form.values);
      props.setOutsideFormValues(props.form.values, () => setSendingUpdate(false));
    }
  }, [props.form.values]);
  useEffect((async () => {
    if (sendingUpdate === false) {
      setSendingUpdate(true);
      try {
        for (const key of Object.keys(props.outsideFormValues)) {
          const value = props.outsideFormValues[key];
          if (props.form.values[key] !== value) {
            await props.form.setFieldValue(key, value, false);
          }
        }
        await sleep(20);
      } catch (e) {
        console.log("Error in EditorFormSync");
      }
      setSendingUpdate(false);
    } else {
      console.log("editor sync loop detected, skipping...");
    }
  }) as any, [props.outsideFormValues]);
  return null;
};

EditorFormSync.defaultProps = {
  outsideFormValues: {},
};

export default React.memo(EditorFormSync);
